import React from "react";
import { UNSUBSCRIBE_SUCCESS_MESSAGES } from "../constants";

const UnsubscribeSuccess = () => (
    <div style={{ padding: 40, textAlign: "center" }}>
        <h2>{UNSUBSCRIBE_SUCCESS_MESSAGES.TITLE}</h2>
        <p>{UNSUBSCRIBE_SUCCESS_MESSAGES.DESCRIPTION}</p>
    </div>
);

export default UnsubscribeSuccess;